import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import flatten from 'lodash/flatten';
import deliveryConstants from '../../constants/deliveryConstants';

export default function getUndeliverableItems(deliveries = [], items = []) {
  const restrictedItemsInDeliveries = deliveries.filter(d => !isEmpty(d.restrictedItemIds));
  const undeliverableDeliveries = deliveries.filter(d => d.type === deliveryConstants.UNDELIVERABLE);

  if (!isEmpty(restrictedItemsInDeliveries)) {
    const matchedItems = [];

    restrictedItemsInDeliveries.forEach((d) => {
      items.forEach((item) => {
        if (includes(d.restrictedItemIds, item.id)) {
          matchedItems.push(item);
        }

        if (item.childItems) {
          item.childItems.forEach((childItem) => {
            if (includes(d.restrictedItemIds, childItem.id)) {
              matchedItems.push(childItem);
            }
          });
        }
      });
    });

    if (!isEmpty(matchedItems)) return matchedItems;
  }

  if (!isEmpty(undeliverableDeliveries)) {
    return flatten(undeliverableDeliveries.map(d => items
      .filter(item => includes(d.itemIds, item.id))
      .map((preOrderItem) => {
        const undeliverableItems = d.items?.filter(deliverableItem => deliverableItem.id === preOrderItem.id);
        const undeliverableReasons = (undeliverableItems && undeliverableItems[0]?.undeliverableReasons) || [];
        return {
          ...preOrderItem,
          ...undeliverableReasons?.length && { undeliverableReasons },
          ...d.streetDate && { streetDate: d.streetDate },
        };
      })));
  }

  return null;
}
